export default {
    commander: 'order',
    informationPersonnelle: 'PERSONAL INFORMATION',
    informationDelivery: 'DELIVERY INFORMATION',
    paymentInformation: 'PAYMENT INFORMATION',
    nextStep: 'Next step',
    confirmOrder: 'Confirm order',
    clientConfirm: {
        orderMade: 'Order made',
        title: 'Beverage Confirmation Number : ',
        description: 'Thanks for your order. <br>You will receive a confirmation email shortly. Do not hesitate <br> to write to us at info@boires.ca if you have any questions. <br>Healthy!',
        rightTitle: 'ORDER TRACKING',
        rightDescription: 'Did you know ? You can track your orders and access your history from your Boires account page!',
        buttonText: 'Access my account'
    },
    guestConfirm: {
        orderMade: 'Order made',
        title: 'Beverage Confirmation Number : ',
        description: 'Thanks for your order. <br>You will receive a confirmation email shortly. Do not hesitate <br> to write to us at info@boires.ca if you have any questions. <br>Healthy!',
        rightTitle: 'ORDER TRACKING',
        rightDescription: 'Did you know ? You can track your orders and access your history from your Boires account page!',
        buttonText: 'Access my account'
    },
    pickupinstore: 'Pick up in shop',
    pickupinstorePlaceholder: 'Choose a shop',
    produitsdelaboutique: 'Shop order',
    produitsdeagence: "Agency products",
    boutiqueProductsSubtitle: 'Shop products',
    pickUp: "For pick up only",
    produitsdeagenceText: "Search for a branch",
    selectBranchError: "Please Select a Branch",
    step1: 'Step 1/3',
    step2: 'Step 2/3',
    step3: 'Step 3/3',
    from: {
        firstName: 'Your first name is required',
        lastName: 'Your last name is required',
        email: 'Your email is required',
        phone: 'Your phone is required',
        password: 'Your password is required',
    },
    noBranchFound: "Branch not found",
    errorMessage1: "Error during payment process",
    errorMessage2: "An error has occurred during payment confirmation!",
};
